import { request } from "../network/request";
const db = "dn0";
//查询任务类型列表
export function trackResult(courseId, page, pageSize) {
    return request({
        url: "course/courseTrack/trackResult",
        method: "get",
        params: {
            db,
            courseId,
            page,
            pageSize
        },
    });
}

export function getCourse(courseId) {
    return request({
        url: "course/courseTrack/getCourse",
        method: "get",
        params: {
            db,
            courseId
        },
    });
}

export function deleteTrack(id) {
    return request({
        url: "course/courseTrack/deleteTrack",
        method: "get",
        params: {
            db,
            id
        },
    });
}

export function trackAdd(params) {
    return request({
        url: "course/courseTrack/trackAdd",
        method: "post",
        data: params,
    });
}

export function makeTrackResult(params) {
    return request({
        url: "course/courseTrack/makeTrackResult",
        method: "post",
        data: params,
    });
}

export function insertTrack(params) {
    return request({
        url: "course/courseTrack/insertTrack",
        method: "post",
        data: params,
    });
}

export function allTrackResult(courseGroup, year, courseName, page, pageSize) {
    return request({
        url: "course/courseTrack/allTrackResult",
        method: "get",
        params: {
            db,
            courseGroup,
            year,
            courseName,
            page,
            pageSize
        },
    });
}

export function exportTrackResult(courseGroup, year, courseName) {
    return request({
        url: "course/courseTrack/exportTrackResult",
        method: "post",
        params: {
            db,
            courseGroup,
            year,
            courseName
        },
    });
}

export function resultScoreList(year, courseName, page, pageSize) {
    return request({
        url: "course/courseIndex/resultScoreList",
        method: "get",
        params: {
            db,
            year,
            courseName,
            page,
            pageSize
        },
    });
}

export function exportScoreList( year, courseName) {
    return request({
        url: "course/courseIndex/exportScoreList",
        method: "post",
        params: {
            db,
            year,
            courseName
        },
    });
}